
import { PackageData } from "@/pages/CreatePackage";
import { TemplateStyle } from "../types";
import { companyName } from "../constants";
import { generateQrCode } from "../helpers";
import { renderCommonSection } from "../commonSections";

const renderSection = (sectionId: string, packageData: PackageData): string => {
  const common = renderCommonSection(sectionId, packageData);
  if (common !== null) return common;

  switch (sectionId) {
    case 'client': {
        const clientCompanyLogoHtml = packageData.companyLogoUrl ? `<img src="${packageData.companyLogoUrl}" alt="شعار شركة العميل" style="max-height: 40px; margin-bottom: 10px; border-radius: 4px;" />` : '';
        const companyNameHtml = packageData.companyName ? `<div class="card"><strong>الشركة:</strong> ${packageData.companyName}</div>` : '';
        return `<div class="section">
                    <h3>معلومات العميل</h3>
                    ${clientCompanyLogoHtml}
                    ${companyNameHtml}
                    <div class="card"><strong>جهة الاتصال:</strong> ${packageData.clientName}</div>
                    <div class="card"><strong>البريد الإلكتروني:</strong> ${packageData.clientEmail}</div>
                </div>`;
    }
    case 'hotels':
      if (packageData.hotels.length === 0) return '';
      return `<div class="section"><h3>الإقامة الفندقية</h3>${packageData.hotels.map(hotel => `<div class="card"><strong>${hotel.name}</strong> - ${hotel.nights} ليالي</div>`).join('')}</div>`;
    case 'flights':
      if (packageData.flights.length === 0) return '';
      return `<div class="section"><h3>رحلات الطيران</h3>${packageData.flights.map(flight => `<div class="card"><strong>${flight.airline}</strong>: ${flight.from} - ${flight.to}</div>`).join('')}</div>`;
    case 'tours':
      if (packageData.tours.length === 0) return '';
      return `<div class="section"><h3>الجولات</h3>${packageData.tours.map(tour => `<div class="card"><strong>${tour.name}</strong><br>${tour.description}</div>`).join('')}</div>`;
    case 'price':
      return `<div class="price-box"><div class="label">التكلفة الإجمالية</div><div class="total">$${packageData.totalPrice}</div></div>`;
    default:
      return '';
  }
};

export const getTemplate3HTML = async (packageData: PackageData, settings: TemplateStyle): Promise<string> => {
  const columnsHtml = settings.columns.map(column => {
    const sectionsHtml = column.sections.map(section => renderSection(section.id, packageData)).join('');
    return `<div class="pdf-column">${sectionsHtml}</div>`;
  }).join('');

  const qrCodeData = await generateQrCode(`Package: ${packageData.packageName}\nClient: ${packageData.clientName}\nPrice: $${packageData.totalPrice}`);
  
  const logoHtml = settings.media?.logo ? `<img src="${settings.media.logo}" alt="Company Logo" style="max-height: 50px; margin-bottom: 10px;" />` : '';
  const backgroundStyle = settings.media?.background ? `background: url('${settings.media.background}') center center / cover no-repeat; background-color: #2c2c2c; background-blend-mode: overlay;` : `background-color: #2c2c2c;`;

  return `
    <!DOCTYPE html>
    <html dir="rtl" lang="ar">
    <head>
      <meta charset="UTF-8">
      <title>عرض سياحي - ${packageData.packageName}</title>
      <link href="https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap" rel="stylesheet">
      <style>
        body { font-family: 'Cairo', sans-serif; background-color: #1a1a1a; color: ${settings.colors.text}; }
        .container { max-width: 800px; margin: 20px auto; border-radius: 8px; box-shadow: 0 10px 30px rgba(0,0,0,0.5); ${backgroundStyle} }
        .header { padding: 40px 30px; background-color: rgba(34,34,34,0.7); text-align: center; border-bottom: 1px solid #444; }
        .company-name { font-size: 16px; color: ${settings.colors.primary}; margin-bottom: 10px; letter-spacing: 2px; text-transform: uppercase; }
        .header h1 { font-size: 32px; margin: 0; color: #fff; }
        .header p { font-size: 18px; color: #aaa; margin: 5px 0 0; }
        .content { padding: 30px; }
        .pdf-row { display: flex; flex-direction: row; gap: 20px; }
        .pdf-column { flex: 1; min-width: 0; }
        .section { margin-bottom: 25px; }
        .section h3 { font-size: 22px; color: ${settings.colors.primary}; margin-bottom: 15px; border-bottom: 1px solid ${settings.colors.primary}; padding-bottom: 5px; display: inline-block; }
        .card { background-color: ${settings.colors.background}; padding: 20px; border-radius: 5px; margin-bottom: 10px; border-left: 3px solid ${settings.colors.primary}; }
        .card strong { color: #e6cfa1; }
        .price-box { padding: 25px; background: linear-gradient(135deg, ${settings.colors.primary}, #e6cfa1); color: #222; text-align: center; border-radius: 5px; margin-top: 30px; }
        .price-box .total { font-size: 36px; font-weight: 700; }
        .price-box .label { font-size: 16px; }
        .footer { text-align: center; color: #888; padding: 20px; font-size: 12px; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          ${logoHtml}
          <div class="company-name">${companyName}</div>
          <h1>${packageData.packageName || 'عرض سياحي فاخر'}</h1>
          <p>${packageData.destination} - ${packageData.duration}</p>
        </div>
        <div class="content">
          <div class="pdf-row">
            ${columnsHtml}
          </div>
          <div class="footer">
            <img src="${qrCodeData}" alt="QR Code" style="width:80px;height:80px;margin:10px auto;" />
            عرض مقدم من ${companyName}
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};
